import { render, staticRenderFns } from "./addBackMan.vue?vue&type=template&id=7c9c123e&scoped=true&"
import script from "./addBackMan.vue?vue&type=script&lang=js&"
export * from "./addBackMan.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/common/nav.less?vue&type=style&index=0&id=7c9c123e&scoped=true&lang=less&"
import style1 from "./addBackMan.vue?vue&type=style&index=1&id=7c9c123e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9c123e",
  null
  
)

export default component.exports